module.exports = __webpack_public_path__ + "manualfiber.pdf?6d639ee85d69227d95a92f61cf6fdb57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/manualfiber.pdf
// module id = 113
// module chunks = 0